export default {
  title: 'Faturas de Pedidos',
  list: {
    empty_list: {
      title: 'Ainda não há Faturas de Pedidos.',
    },
    fields: {
      id: 'Id',
      total: 'Total',
      date: 'Data',
    },
  },
  export_modal: {
    title: 'Filtrar',
    start_date: {
      title: 'Data de Início',
      placeholder: 'data',
    },
    end_date: {
      title: 'Data de Fim',
      placeholder: 'data',
    },
    button: {
      title1: 'Aplicar',
      title2: 'Fechar',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
